// Mock data for AthloPeak landing page

export const mockFeatures = [
  {
    id: 1,
    title: "Custom Programs",
    description: "Your training plan. Built around your schedule, your experience, and what you want to achieve.",
    icon: "Dumbbell"
  },
  {
    id: 2,
    title: "Nutrition That Fits",
    description: "Eat to support your training. Simple guidelines that match your workout intensity and goals.",
    icon: "Apple"
  },
  {
    id: 3,
    title: "See Real Results",
    description: "Track your lifts, measurements, and progress photos. Watch yourself get stronger week by week.",
    icon: "TrendingUp"
  }
];

export const mockSteps = [
  {
    id: 1,
    step: "01",
    title: "Tell Us Your Goal",
    description: "Building muscle? Losing weight? Getting stronger? Whatever it is, start here."
  },
  {
    id: 2,
    step: "02",
    title: "Follow Your Plan",
    description: "You get a training program and nutrition guide built for your schedule and experience level."
  },
  {
    id: 3,
    step: "03",
    title: "Watch It Work",
    description: "Track every workout, every measurement. See what's changing week by week."
  }
];

export const mockPricing = [
  {
    id: 1,
    name: "Monthly",
    price: "14.99",
    interval: "month",
    totalPrice: "14.99",
    discount: null,
    features: [
      "Your own personal trainer with unique instructions",
      "Personalized meals - never think what to eat",
      "One-tap meal swap - replace in 1 second",
      "Anatomical diagrams - see which muscles you train",
      "For every athlete - fitness, weight loss, bulking, sports",
      "Race prep: 5K, 10K, half marathon, marathon, triathlon",
      "Pregnancy support - safe workouts + adapted nutrition",
      "Unlimited planning - plan months ahead",
      "Progress tracking with detailed graphs",
      "Auto-adapts to your level and performance",
      "Save thousands - no expensive PT needed",
      "And much more!"
    ],
    popular: false
  },
  {
    id: 2,
    name: "6 Months",
    price: "11.99",
    interval: "month",
    totalPrice: "71.95",
    discount: "20% OFF",
    features: [
      "Your own personal trainer with unique instructions",
      "Personalized meals - never think what to eat",
      "One-tap meal swap - replace in 1 second",
      "Anatomical diagrams - see which muscles you train",
      "For every athlete - fitness, weight loss, bulking, sports",
      "Race prep: 5K, 10K, half marathon, marathon, triathlon",
      "Pregnancy support - safe workouts + adapted nutrition",
      "Unlimited planning - plan months ahead",
      "Progress tracking with detailed graphs",
      "Auto-adapts to your level and performance",
      "Save thousands - no expensive PT needed",
      "And much more!"
    ],
    popular: true
  },
  {
    id: 3,
    name: "Annual",
    price: "10.49",
    interval: "month",
    totalPrice: "125.92",
    discount: "30% OFF",
    features: [
      "Your own personal trainer with unique instructions",
      "Personalized meals - never think what to eat",
      "One-tap meal swap - replace in 1 second",
      "Anatomical diagrams - see which muscles you train",
      "For every athlete - fitness, weight loss, bulking, sports",
      "Race prep: 5K, 10K, half marathon, marathon, triathlon",
      "Pregnancy support - safe workouts + adapted nutrition",
      "Unlimited planning - plan months ahead",
      "Progress tracking with detailed graphs",
      "Auto-adapts to your level and performance",
      "Save thousands - no expensive PT needed",
      "And much more!"
    ],
    popular: false
  }
];

export const mockAppFeatures = [
  {
    id: 1,
    title: "Custom Programs",
    description: "Built for your goals and schedule"
  },
  {
    id: 2,
    title: "Nutrition Guidance",
    description: "Eat to support your training"
  },
  {
    id: 3,
    title: "See Results",
    description: "Track every improvement"
  },
  {
    id: 4,
    title: "Stay Consistent",
    description: "Build the habit that lasts"
  },
  {
    id: 5,
    title: "From €10.49/Month",
    description: "Elite coaching at a fraction of the cost"
  },
  {
    id: 6,
    title: "Save Hundreds",
    description: "PT + dietitian cost €300-500/month"
  }
];
